// extracted by mini-css-extract-plugin
export default {"btn-accept":"ActionStyles_btn-accept__yD2DY","btn-cancel":"ActionStyles_btn-cancel__ASub3","mr-12":"ActionStyles_mr-12__k0kiy"};